import React, { useState, useEffect } from "react";
import { FormControl, FormLabel, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import FilterDropdown from "../../../utilities/FilterDropdown";
import UserCard from "../../../utilities/UserCard";
import AddCustomer from "../DealerPanel/AddCustomer";
import axios from "../../../../utils/axios";

const DealerCustomerListing = () => {
  const [addNew, setAddNew] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [show, setShow] = useState(false);
  const [customerDetail, setCustomerDetail] = useState([]);
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  const [sortOrder, setSortOrder] = useState("");

  const getList = async () => {
    try {
      const response = await axios.post("view/dealer/customers");
      if (response?.data?.length > 0) {
        setCustomerList(response?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const sortedDevices = () => {
    let filteredDevices = customerList;

    if (sortOrder === "Name A-Z") {
      return filteredDevices.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortOrder === "Name Z-A") {
      return filteredDevices.sort((a, b) => b.name.localeCompare(a.name));
    } else {
      return filteredDevices;
    }
  };

  const handleSortChange = (selectedOption) => {
    setSortOrder(selectedOption);
  };

  useEffect(() => {
    getList();
  }, [addNew]);

  useEffect(() => {
    setName(customerDetail.name);
    setCompany(customerDetail.company_name);
    setPhone(customerDetail.mobile_no);
    setEmail(customerDetail.email_id);
  }, [customerDetail]);

  const handleClose = () => setShow(false);

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios
          .post("delete/customer", {
            id,
          })
          .then(() => {
            Swal.fire({
              title: "Success",
              text: "Customer deleted",
              icon: "success",
            });
          })
          .catch((error) => console.log(error));

        getList();
      }
    });
  };

  const handleUpdate = async (id) => {
    await axios
      .post("view/customer/detail/device/list", {
        customerId: id,
      })
      .then((response) => {
        setCustomerDetail(response.data.customerDetails);
      })
      .catch((error) => console.log(error));

    getList();

    setShow(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pass === "" && confirmPass === "") {
      try {
        await axios.post("change/customer/details", {
          id: customerDetail.id,
          name,
          company_name: company,
          mobile_no: phone,
          email_id: email,
        });

        Swal.fire({
          title: "Success",
          text: "Details are successfully updated",
          icon: "success",
        });
        setShow(false);
        getList();
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to update details";
        Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } else if (confirmPass === pass) {
      try {
        await axios.post("change/customer/details", {
          id: customerDetail.id,
          name,
          company_name: company,
          mobile_no: phone,
          email_id: email,
          password: pass,
        });

        Swal.fire({
          title: "Success",
          text: "Details are successfully updated",
          icon: "success",
        });
        setShow(false);
        getList();
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to update details";
        Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } else {
      Swal.fire({
        title: "Error",
        text: "Password and confirm password must be the same",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  const handleReset = () => {
    setName("");
    setCompany("");
    setPass("");
    setCompany("");
    setConfirmPass("");
    setEmail("");
  };

  return (
    <>
      {/* <Loading /> */}
      <div className="listing-page">
        <div className="device-head d-flex align-items-center justify-content-between">
          <h3 className="title">customer list</h3>

          <div className="right-btn-wrap d-flex align-items-center justify-content-end">
            <button className="add-new" onClick={() => setAddNew(true)}>
              Add <span>+</span>
            </button>
            <FilterDropdown
              placeholder="Sort By"
              options={["Name A-Z", "Name Z-A"]}
              onOptionSelect={(option) => handleSortChange(option)}
              onChange={handleSortChange}
            />
          </div>
        </div>

        <div className="customer-listing">
          {sortedDevices().map((item, index) => (
            <div>
              <UserCard
                link={`/dealer-customer/customer-detail/${item?.id}`}
                key={index}
                name={item.name}
                company={item.company_name}
                assignee={item.deviceCount}
                date={new Date(item.join_date).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}
                phone={item.mobile_no}
                email={item.email_id}
                onClick={() => handleDelete(item.id)}
                onUpdate={() => handleUpdate(item.id)}
                id={item.id}
              />
            </div>
          ))}
        </div>
      </div>

      <AddCustomer show={addNew} onHide={() => setAddNew(false)} />
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="modal-75w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <button className="close-icon" onClick={handleClose}>
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.4039 15.7032L30.3126 3.81334C30.6685 3.4574 30.8685 2.97463 30.8685 2.47125C30.8685 1.96787 30.6685 1.4851 30.3126 1.12916C29.9567 0.77321 29.4739 0.573242 28.9705 0.573242C28.4671 0.573242 27.9844 0.77321 27.6284 1.12916L15.7386 13.0379L3.84879 1.12916C3.49285 0.77321 3.01008 0.573243 2.5067 0.573243C2.00332 0.573243 1.52055 0.77321 1.16461 1.12916C0.808663 1.4851 0.608695 1.96787 0.608695 2.47125C0.608695 2.97463 0.808663 3.4574 1.16461 3.81334L13.0733 15.7032L1.16461 27.593C0.987436 27.7687 0.846811 27.9778 0.750844 28.2081C0.654878 28.4385 0.605469 28.6855 0.605469 28.9351C0.605469 29.1846 0.654878 29.4317 0.750844 29.662C0.846811 29.8924 0.987436 30.1014 1.16461 30.2772C1.34033 30.4543 1.5494 30.595 1.77975 30.6909C2.01009 30.7869 2.25716 30.8363 2.5067 30.8363C2.75624 30.8363 3.00331 30.7869 3.23366 30.6909C3.464 30.595 3.67307 30.4543 3.84879 30.2772L15.7386 18.3684L27.6284 30.2772C27.8041 30.4543 28.0132 30.595 28.2435 30.6909C28.4739 30.7869 28.721 30.8363 28.9705 30.8363C29.22 30.8363 29.4671 30.7869 29.6975 30.6909C29.9278 30.595 30.1369 30.4543 30.3126 30.2772C30.4898 30.1014 30.6304 29.8924 30.7264 29.662C30.8223 29.4317 30.8717 29.1846 30.8717 28.9351C30.8717 28.6855 30.8223 28.4385 30.7264 28.2081C30.6304 27.9778 30.4898 27.7687 30.3126 27.593L18.4039 15.7032Z"
              fill="black"
            />
          </svg>
        </button>
        <Modal.Body>
          <h4 className="modal-title">Edit Customer</h4>
          <form action="" className="modal-form">
            <div className="form-fields">
              <div>
                <FormLabel>Customer Name</FormLabel>
                <FormControl
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter Customer Name....."
                />
              </div>

              <div>
                <FormLabel>Company Name</FormLabel>
                <FormControl
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  placeholder="Enter Company Name....."
                />
              </div>

              <div>
                <FormLabel>Phone</FormLabel>
                <FormControl
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  type="number"
                  placeholder="Enter Phone Number....."
                />
              </div>

              <div>
                <FormLabel>Email</FormLabel>
                <FormControl
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="Enter Your Email....."
                />
              </div>

              <div>
                <FormLabel>New Password</FormLabel>
                <FormControl
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                  type="password"
                  placeholder="Enter Your Password....."
                />
              </div>

              <div>
                <FormLabel>Confirm New Password</FormLabel>
                <FormControl
                  value={confirmPass}
                  onChange={(e) => setConfirmPass(e.target.value)}
                  type="password"
                  placeholder="Enter Confirm Password....."
                />
              </div>
            </div>

            <div className="form-btn d-flex align-items-center mt-5">
              <button
                onClick={handleSubmit}
                type="submit"
                className="white-btn"
              >
                Save
              </button>
              <button onClick={handleReset} className="white-btn ms-4">
                Reset
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DealerCustomerListing;
